import { render, staticRenderFns } from "./PurchaseOverviewWidget.vue?vue&type=template&id=2edd1332&"
import script from "./PurchaseOverviewWidget.vue?vue&type=script&lang=js&"
export * from "./PurchaseOverviewWidget.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOverviewWidget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtnToggle,QSeparator,QDialog,QAvatar,QCardActions,QBtn,QSelect,QItem,QItemSection,QInput,QIcon,QPopupProxy,QDate,QTable,QTr,QTh,QTd,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtnToggle,QSeparator,QDialog,QAvatar,QCardActions,QBtn,QSelect,QItem,QItemSection,QInput,QIcon,QPopupProxy,QDate,QTable,QTr,QTh,QTd})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
